<template>
  <div class="wrap">
    <div class="flex space-between pad20_tb align-center">
      <div>填写核对订单</div>
      <div class="flex f12 align-center">
        <div class="flex align-center">
          <span class="pad5_lr radius_50 white bg-red-color">1</span>
          <span class="red-color mar5_l">我的进货车</span>
        </div>
        <div class="flex align-center red-color">
          <i class="el-icon-right pad5_lr"></i>
          <span class="pad5_lr radius_50 white bg-red-color">2</span>
          <span class="mar5_l">我的进货车</span>
        </div>
        <div class="flex align-center">
          <i class="el-icon-right pad5_lr"></i>
          <span class="pad5_lr radius_50" :class="1 ? '' : 'white bg-red-color'"
            >3</span
          >
          <span class="mar5_l">成功提交订单</span>
        </div>
      </div>
    </div>
    <div v-for="item in [1, 2]" :key="item" class="pad10_tb">
      <div class="pad20_lr pad20_b flex">
        <div class="flex align-center">
          <i class="el-icon-s-shop pad5_lr"></i>
          <span>卖家店ydemoiy</span>
        </div>
        <div class="flex mar20_l align-center">
          <i class="el-icon-s-comment pad5_lr color-4ca44d"></i>
          <span>和买家联系</span>
        </div>
      </div>
      <div class="bg-white border">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            label="货品"
            width="360px"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="flex">
                <el-image :src="scope.row.img" class="w90" fit="contain"
                  ><div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div></el-image
                >
                <div class="pad10_l text-left">
                  <div class="flex align-center">
                    <el-tag
                      type="danger"
                      effect="dark"
                      size="mini"
                      class="mar5_r"
                      >赠</el-tag
                    >
                    <div class="ellipsis-2">
                      {{ scope.row.name }}
                    </div>
                  </div>
                  <div class="gray9">
                    <span>规格：</span>
                    {{ scope.row.goodsSpecTxt }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="价格"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="gray6 line-through">{{ scope.row.price1 }}</div>
              <div class="">{{ scope.row.price2 }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="数量"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                v-model="scope.row.num"
                @change="handleChange"
                :min="1"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="金额"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span class="red-color">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="优惠信息"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span class="bg-red-color white pad5_lr">折扣</span>
              <span class="red-color">{{ scope.row.info }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pad20_tb">
          <div class="pad20_lr">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="配送方式:">
                <el-radio-group v-model="form.psfs" size="small">
                  <el-radio-button label="0">买家自提</el-radio-button>
                  <el-radio-button label="1">卖家配送</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <template v-if="form.psfs === '0'">
                <el-form-item label="自提地址:" size="small">
                  <el-radio-group v-model="form.ztdz">
                    <el-radio label="1" border
                      >北京市海淀区中关村大街27号中关村大厦</el-radio
                    >
                    <el-radio label="2" border
                      >北京市海淀区中关村大街27号中关村大厦14层</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="自提时间:">
                  <div class="flex align-center">
                    <el-radio-group v-model="form.ztsj" size="small">
                      <el-radio-button label="0">今天</el-radio-button>
                      <el-radio-button label="1">明天</el-radio-button>
                      <el-radio-button label="2">后天</el-radio-button>
                    </el-radio-group>
                    <div class="flex pad20_l">
                      <span class="pad10_r">自定义</span>
                      <el-date-picker
                        v-model="form.ztsj"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        size="small"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="收货信息:">
                  <div class="flex align-center">
                    <div>何小龙</div>
                    <div class="flex red-color align-center pad20_lr">
                      <i class="el-icon-phone pad5_lr"></i>
                      1342323232323
                    </div>
                    <div class="flex align-center">
                      <i class="el-icon-location pad5_lr color-4ca44d"></i>
                      北京市海淀区中关村大街27号中关村大厦
                    </div>
                    <div class="pad5_lr">
                      <span class="bg-red-color white">该地址不支持配送</span>
                    </div>
                  </div>
                  <div class="flex align-center">
                    <div class="flex align-center">
                      <i class="el-icon-edit pad5_lr"></i>
                      修改
                    </div>
                    <div class="flex align-center pad10_l">
                      <i class="el-icon-circle-plus-outline pad5_lr"></i>
                      新增
                    </div>
                  </div>
                </el-form-item>
              </template>

              <el-form-item label="买家留言:">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请写下想对卖家说的话"
                  v-model="form.textarea"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <el-divider></el-divider>
          <div class="pad20_lr">
            <div class="flex align-center pad10_tb">
              <div class="pad20_r">
                <el-radio v-model="radio" label="1">使用折扣券抵扣</el-radio>
              </div>
              <div class="flex pad5_lr">
                可用金额<span class="pad5_lr red-color">1000</span
                >元，本次使用折扣券抵扣
              </div>
              <div class="flex align-center">
                <el-input v-model="input"></el-input>
                <span class="pad5_lr">元</span>
              </div>
            </div>
            <div class="flex align-center pad10_tb">
              <div class="pad20_r">
                <el-radio v-model="radio" label="1">使用预付款抵扣</el-radio>
              </div>
              <div class="flex pad5_lr">
                可用金额<span class="pad5_lr red-color">1000</span
                >元，本次使用预付款抵扣
              </div>
              <div class="flex align-center">
                <el-input v-model="input"></el-input>
                <span class="pad5_lr">元</span>
              </div>
            </div>
            <div class="flex align-center pad10_tb">
              <div class="pad20_r">
                <el-radio v-model="radio" label="1">使用现金券抵扣</el-radio>
              </div>
              <div class="flex pad5_lr">
                可用现金券<span class="pad5_lr red-color">1000</span
                >张，本次使用现金券
              </div>
              <div class="flex align-center">
                <div>
                  <el-input v-model="input"></el-input>
                </div>
                <span class="pad5_lr">张</span>
                <div class="flex align-center">
                  抵扣
                  <span class="red-color">1000</span>
                  元
                </div>
              </div>
            </div>
            <div class="flex align-center pad10_tb">
              <div class="pad20_r">
                <el-radio v-model="radio" label="1"
                  >使用店铺优惠券抵扣</el-radio
                >
              </div>
              <div class="flex pad5_lr">已抵扣1000元</div>
              <div
                class="flex align-center red-color"
                @click="centerDialogVisible = true"
              >
                <span class="">查看优惠券</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="bg-f4 mar40_l pad5">
                <el-radio disabled label="4"
                  >无可用优惠券，优惠券已失效</el-radio
                >
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="flex flex-end pad20_lr align-center">
            <div class="flex">共30件货品</div>
            <div class="flex align-center">
              <span>小计：</span>
              <span class="red-color f20">￥454545</span>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="flex pad20_lr">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="支付方式:">
                <el-radio-group v-model="form.zffs" size="small">
                  <el-radio-button label="0">在线支付</el-radio-button>
                  <el-radio-button label="1">当面结算</el-radio-button>
                  <el-radio-button label="2">暂不支付</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开具发票:">
                <el-radio-group v-model="form.fp">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-input
                class="flex"
                size="small"
                v-if="form.fp === '1'"
                v-model="form.fptt"
                placeholder="填写发票抬头"
              >
              </el-input>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="pad20_tb">
      <div class="bg-white border">
        <div class="pad20">
          <div class="flex flex-end pad5_tb">
            <span>货品总额：</span>
            <span class="red-color pad20_lr">￥454545</span>
          </div>
          <div class="flex flex-end pad5_tb">
            <span>价格优惠：</span>
            <span class="red-color pad20_lr">￥454545</span>
          </div>
          <div class="flex flex-end pad5_tb">
            <span>折扣券抵扣：</span>
            <span class="red-color pad20_lr">￥454545</span>
          </div>
          <div class="flex flex-end pad5_tb">
            <span>现金券抵扣：</span>
            <span class="red-color pad20_lr">￥454545</span>
          </div>
        </div>
      </div>
      <div class="bg-white border">
        <div class="flex flex-end align-center">
          <div class="flex align-center pad20_lr">
            <span>应付总额：</span>
            <span class="red-color f20">￥454545</span>
          </div>
          <div class="white bg-red-color pad20 f20">提交订单</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" center>
      <template>
        <span>选择适用的优惠券</span>
      </template>
      <span slot="title">
        <div class="text-left">我的优惠券</div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
        <el-button @click="centerDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style lang="scss" scoped>
@import "./style.scss";
.el-dialog__header {
  background: #f4f4f4;
}
</style>
<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      form: {},
      tableData: [
        {
          num: 3,
          name: '商品名称上海市普陀区金沙江路上海市普陀区金沙江路',
          price1: '34.99',
          price2: '35.99',
          money: '￥454545',
          info: '直降49元',
        },
        {
          num: 3,
          name: '商品名称上海市普陀区金沙江路上海市普陀区金沙江路',
          price1: '34.99',
          price2: '35.99',
          money: '赠品',
          info: '折扣大促销',
        },
      ],
    };
  },
  created() {},
};
</script>
